<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <a-form-item label="ApplicationName" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input placeholder="Please enterApplicationName" v-model="queryParam.appName"></a-input>
            </a-form-item>
          </a-col>
            <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class="table-operator" style="border-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus">Add</a-button>
      </div>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x:1000}"
        bordered
        @change="handleTableChange">
        <Dict slot="collectorType" slot-scope="text" :dict-code="DICT_CODE. COLLECTOR_TYPE" :value="text"/>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">
            Edit
          </a>
          <a-divider type="vertical"/>
          <a @click="editSubApp(record)">Add Sub Product</a>
          <a-divider type="vertical"/>
          <a @click="editUser(record)">Employee Management</a>
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="editDictItem(record)"><a-icon type="setting"/> Dictionary config</a>-->
          <a-divider type="vertical"/>
          <a-popconfirm title="ConfirmDelete??" @confirm="() =>handleDelete(record.id)">
            <a>Delete</a>
          </a-popconfirm>
        </span>
      </a-table>

    </div>
    <app-modal ref="modalForm" @ok="modalFormOk"></app-modal>
    <employee ref="employee"></employee>
    <AppStrategyidSetting ref="appStrategyidSetting"></AppStrategyidSetting>
    <sub-app-list ref='subAppList'></sub-app-list>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAppList, deleteApp, getDurationsByAppParentId } from '@/webpublicapi/system'
import Dict from '../modules/Dict';
import AppModal from './modules/AppModal'
import Employee from './Employee'
import AppStrategyidSetting from './modules/AppStrategyidSetting'
import SubAppList from './SubAppList'

export default {
  name: 'appList',
  components: {
    AppModal,
    SubAppList,
    Employee,
    AppStrategyidSetting,
    Dict
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      visible: false,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dataSource: [],
      // Query conditions
      queryParam: {
        appName: '',
      },
      loading: false,
      // Table header
      columns: [
        {
          title: 'ApplicationName',
          align: 'left',
          width: '100px',
          dataIndex: 'appName'
        },
        {
          title: 'Tenant ID',
          align: 'left',
          width: '100px',
          dataIndex: 'appSsid'
        },
        {
          title: 'Package Name',
          align: 'left',
          width: '100px',
          dataIndex: 'appPackageName'
        },
        {
          title: 'logo',
          align: 'left',
          width: '400px',
          dataIndex: 'logoUrl'
        },
        {
          title: 'Collection Type',
          align: 'left',
          dataIndex: 'collectorType',
          width: '100px',
          scopedSlots: { customRender: 'collectorType' },
        },
        {
          title: 'APP Version',
          align: 'left',
          dataIndex: 'appVersion',
          width: '100px',
        },
        {
          title: 'APPDownloadAddress',
          align: 'left',
          dataIndex: 'appDownUrl',
          width: '100px',
        },{
          title: 'Push Recommended',
          align: 'left',
          dataIndex: 'vipProductViewFlag',
          width: '100px',
        },{
          title: 'Customer Service Phone',
          align: 'left',
          dataIndex: 'appMobile',
          width: '100px',
        },{
          title: 'Schame',
          align: 'left',
          dataIndex: 'appSchame',
          width: '100px',
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          width: '300px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    //Get product term list under this app
    getDurationsByAppParentId(parentId) {
      getDurationsByAppParentId(parentId).then(res => {
        this.curDurations += res.data.toString()
      })
    },

    //Show modal
    showModal(record) {
      this.parentId = record.id
      this.getDurationsByAppParentId(this.parentId)
      this.visible = true;
    },
    //Close modal
    handleCancel() {
      this.close()
    },

    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getAppList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    getQueryParams () {
      var param = Object.assign({}, this.queryParam, this.isorter)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = 'Add'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleDelete(id){
      deleteApp({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    editUser (record) {
      this.$refs.employee.edit(record)
    },
    editSubApp (record) {
      this.$refs.subAppList.edit(record)
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.appName = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    } ,
    // Edit
    editDictItem (record) {
      this.$refs.appStrategyidSetting.edit(record)
    },
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
